import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"

export default function SortDropdown() {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);

    // keydown 'esc' will close dropdown
    useEffect(() => {
        const handleKeydown = (event) => {
            if(event.key === 'Escape' || event.keyCode === 27) {
                toggleSort();
            }
        }

        if(sortOpen) {
            window.document.addEventListener('keydown', handleKeydown)
            return () => window.document.removeEventListener('keydown', handleKeydown)
        }
    }, [ sortOpen ])

    // click outside will close dropdown
    useEffect(() => {
        const handleClick = (event) => {
            if(
                !dropdownRef.current.contains(event.target) && 
                !toggleRef.current.contains(event.target)
            ) {
                toggleSort();
            };
        };

        if(sortOpen && dropdownRef?.current && toggleRef?.current) {
            window.document.addEventListener('click', handleClick);
            return () => window.document.removeEventListener('click', handleClick);
        };
    }, [sortOpen, dropdownRef, toggleRef]);

    const handleSortChange = (event) => {
        setSort(event.target.value);
        toggleSort();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    return (
        <div class="ns-toolbar__controls-sort ns-custom-dropdown">
            <button 
                type="button"
                aria-haspopup="true"
                aria-controls="ns-sort-dropdown" // match id
                aria-labelledby="sort-label"
                aria-expanded={sortOpen}
                tabIndex="0"
                onClick={toggleSort}
                ref={toggleRef}
            >
                SORT {sortOpen ? "-" : "+"}
            </button>
            <div>
                <ul
                    id="ns-sort-dropdown" // make unique
                    className="ns-custom-dropdown__body ns-p-0 ns-m-0"
                    aria-expanded={sortOpen}
                    ref={dropdownRef}
                    role="menu"
                >
                    {sortOptions.map((option) => (
                        <li 
                            class="ns-sort-option"
                            key={option.id}
                        >
                            <label>
                                <input
                                    class="visually-hidden"
                                    type="radio"
                                    name="ns-sort"
                                    value={option.id} 
                                    checked={(activeSort === option.id)}
                                    onChange={handleSortChange}
                                />
                                {option.value.name}
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
